import styled from 'styled-components';
import dynamic from 'next/dynamic';

const MapContainer = dynamic(() => import('./components/MapContainer'), {
  ssr: false
});

interface MapboxProps {
  isSahel?: boolean;
}

const Mapbox = ({ isSahel }: MapboxProps) => {
  return (
    <Container>
      <MapContainer isSahel={isSahel} />
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  max-height: 100dvh;
  overflow: hidden;
`;

export default Mapbox;
